@import "@zvuk-b2b/react-uikit/ui/styles/_variables";
@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

@keyframes anm-gradient {
    0% {
        background-position: 0 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

.SmartMenuItemLink {
    width: 100%;
    overflow: hidden;
}

.SmartMenuItemContent {
    display: flex;
    align-items: center;
    position: relative;
    min-height: 36px;
    padding: 0 12px;
    cursor: pointer;
    width: 100%;
    overflow: hidden;
    border-radius: $border-radius-8;
    transition:
            color $transition-duration-s,
            opacity $transition-duration-s,
            stroke $transition-duration-s,
            fill $transition-duration-s,
            background $transition-duration-s;

    &:hover {
        background: $color-neutral-50;
    }

    &[data-selected=false] {
        color: $color-neutral-500;
        stroke: $color-neutral-500;
        fill: $color-neutral-500;
    }

    &[data-selected=true] {
        color: $color-neutral-700;
        stroke: $color-neutral-700;
        fill: $color-neutral-700;
        background: $color-neutral-50;
    }

    &[data-marked=true] {
        color: $color-neutral-50;
        stroke: $color-neutral-50;
        fill: $color-neutral-50;
        background: linear-gradient(269.59deg, #515DAD 0, #8253AA 100%);
        background-size: 400% 400%;
        animation: anm-gradient 4s ease infinite;
    }

    &Noticed {
        background-color: $color-warning-500;
        border-radius: 100px;
        width: 8px;
        height: 8px;
        position: absolute;
        top: 4px;
        left: 28px;
    }

    &Title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
        transition: opacity $transition-duration-m;

        &[data-hidden=true] {
            opacity: 0;
        }

        &[data-hidden=false] {
            opacity: 1;
        }
    }

    &Icon {
        pointer-events: none;
        margin-right: $ceil;
        transition: opacity $transition-duration-m;
        position: relative;

        @include media-mobile {
            opacity: 0;
        }

        @include media-desktop {
            opacity: 1;
        }

        &Expanded {
            @include media-mobile {
                opacity: 1;
            }

            @include media-desktop {
                opacity: 1;
            }
        }
    }

    &Badge {
        align-self: flex-start;
        font-size: $font-size-10;
        border-radius: 4px;
        padding: 0 4px;
        position: absolute;
        top: -4px;
        right: $ceil * -5;
        height: 16px;

        &[data-type=danger] {
            color: $color-white;
            background-color: #F24727;
        }
    }
}

.withError::after {
    position: absolute;
    content: ' ';
    width: 8px;
    height: 8px;
    background: $color-danger-400;
    top: 1px;
    right: -3px;
    border-radius: 50%;
}
